import styled from "styled-components";

export const HomeComponentMainDiv = styled.main`
  width: 100%;
  overflow:hidden;

  .video-container {
    top: 0px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    position: absolute;
    z-index: 0;
      overflow:hidden;

  }
  .video-holder {
    > video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .content {
    z-index: 1;
  }
  @media (max-width: 450px) {
  width:100vw;
  .video-holder {
    top: 0px;
    width: 300%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    z-index: 0;
  }
  }
`;
